export default "__VITE_ASSET__CDKKrChz__"